/** @format */

import { _$, Form } from '@king-design/react'
import yaml from 'js-yaml'
import dayjs from 'dayjs'
// 添加全局规则

// 数字类型
Form.addMethod(
  'isNumber',
  value => {
    return /^(-?\d+)(\.?\d+)?$/.test(value)
  },
  _$('请输入数字类型')
)
// 小数点后三位规则
Form.addMethod(
  'pointsLimit',
  value => {
    return /(^[0-9]{1,}$)|(^[0-9]{1,}\.{1}[0-9]{1,3}$)/.test(value)
  },
  _$('仅支持输入小数点后三位有效数字')
)
// 网址
Form.addMethod(
  'isWebAddress',
  value => {
    return (
      /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'*+,;=.]+$/.test(value) ||
      /^(.)+@(.)+$/.test(value) ||
      /^(.)+:(.)+$/.test(value)
    )
  },
  _$('请输入正确地址')
)

// 所有姓名
Form.addMethod(
  'userName',
  value => {
    return /^[-a-zA-Z0-9\u4E00-\u9FA5,_@#.]{2,64}$/.test(value)
  },
  _$('2-64个字符组成，支持中文，字母，数字，以及,-_@#.')
)

// 所有描述
Form.addMethod(
  'description',
  value => {
    return /^.{2,512}$/.test(value)
  },
  _$('2-512个字符组成')
)

// 手机号
Form.addMethod(
  'phone',
  value => {
    return /^1[3|4|5|6|7|8|9]\d{9}$/.test(value)
  },
  _$('请输入正确的手机号码')
)

// 验证码
Form.addMethod(
  'verifyCode',
  value => {
    return /^\d{6}$/.test(value)
  },
  _$('请输入6位数字验证码')
)

// 字符串拆分后验证网址类型
Form.addMethod(
  'verifyAdress',
  value => {
    const mail_arr = value.split(',')
    let result = true
    const reg = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
    for (let i = 0; i < mail_arr.length; i++) {
      mail_arr[i] = mail_arr[i].replace(/\s*/g, '')
      if (!reg.test(mail_arr[i])) {
        result = false
        return
      }
    }
    return result
  },
  _$('请输入正确的邮箱地址，多个邮箱用逗号( , )分割,最后一个邮箱不用加逗号')
)

// 金额（数字，小数点后最多保留两位）
Form.addMethod(
  'amount',
  value => {
    return /(^[0-9]{1,}$)|(^[0-9]{1,}\.{1}[0-9]{1,2}$)/.test(value)
  },
  _$('最多保留两位小数')
)

// 所有姓名
Form.addMethod(
  'yaml',
  value => {
    try {
      yaml.load(value)
      return true
    } catch (e) {
      return false
    }
  },
  _$('请输入正确的yaml格式')
)

// 告警规则:label-value && annotation-value
Form.addMethod(
  'ruleDescription',
  value => {
    return /^[\u4E00-\u9FFF\u3000-\u303F\uFF00-\uFFEF\u0020-\u007E\n\r\t]{2,4096}$/.test(value)
  },
  '2-4096个字符组成，支持中文，字母，数字，以及常见符号'
)

// 告警规则:label-key && annotation-key
Form.addMethod(
  'ruleLabelKey',
  value => {
    return /^[a-z][a-z0-9_]{1,63}$/.test(value)
  },
  '2-64个字符组成，小写字母开头，支持小写字母，数字以及_'
)

// 验证Object的length
Form.addMethod(
  'ObjectLength',
  value => {
    return !!Object.keys(value).some(key => value[key].Value)
  },
  '字段不能为空'
)

// 名称验证
export const nameValidate = value => {
  return /^[a-z,\u4E00-\u9FA5,0-9,A-Z,-_@#.]{2,64}$/.test(value)
}

// 验证字段不可以重复
export const uniqueValidate = (value: string, list, key: string, errorMsg: string) => {
  let count = 0
  if (value && list?.length) {
    list.find(item => {
      if (item[key] === value) {
        count++
      }
      return count > 1
    })
    return count === 1 || errorMsg
  }
  return true
}

// 告警抑制/告警静默 规则Values验证
// Values 最大4096个字符，单个value最大512个字符，最大10个
Form.addMethod('denoiseRuleValuesValidate', value => {
  const valueStr = value.join('\n')
  if (value.length > 10) {
    return 'Value数量最多10个'
  } else if (value.some(item => item.length < 2 || item.length > 512)) {
    return '单个Value长度为2-512个字符'
  } else if (valueStr.length > 5120) {
    return 'Values总长度最大5120个字符'
  }
  return true
})

// 验证时间必须大于当前时间
Form.addMethod(
  'endTimeValidate',
  value => {
    if (value?.length === 2) {
      return dayjs().isBefore(dayjs(value[1]))
    } else {
      return true
    }
  },
  '结束时间必须大于当前时间'
)

// 验证字符串切割成数组后最大长度
Form.addMethod('denoiseEqualsMaxLength', value => {
  const splitValue = value.split('\n')
  if (splitValue.length > 20) {
    return '匹配条件最多20个'
  }
  return true
})
